import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class LogoUpdateService {
    private subject = new Subject<string>();

    sendMessage(url: string) {
        this.subject.next(url);
    }

    clearMessage() {
        this.subject.next();
    }

    getMessage(): Observable<string> {
        return this.subject.asObservable();
    }
}
